import styled from 'styled-components';

export const DomainText = styled.p`
  font-size: 14px;
  color: ${props => props.theme.interface5};
  margin-bottom: 10px;
`;
